import { Environment } from './environment.interface';
import { version as appVersion } from '../package.json';

export const environment: Environment = {
  production: false,
  appVersion,
  apiEndpoint: 'https://api.chat.spyro-dev.net',
  supportEmail: 'leap@spyro-soft.com',
  amlIndexingEndpointName: 'leap-indexing-endpoint-dev',
  msal: {
    auth: {
      clientId: '5abbf688-c0cf-4d35-b18b-47f146aa4135',
      authority: 'https://login.microsoftonline.com/fbcab9a6-38ab-4bcd-ab3d-a468c8ee380c',
      redirectUri: 'https://chat.spyro-dev.net/'
    },
    graphEndpoint: 'https://graph.microsoft.com/v1.0/me',
    apiScopes: ['5abbf688-c0cf-4d35-b18b-47f146aa4135/.default']
  }
};

console.warn('Application runs with development environment configuration');
